import { useCallback, useState } from "react";
import { Box } from "@mui/material";
import { Patrol } from "./Patrol.jsx";
import "../../../styles/omniWatchPlace360.css";

export default function DigitalPatrolShell() {
  const [selectedDrawingForView, setSelectedDrawingForView] = useState(null);
  const onClearSelectedDrawing = useCallback(
    () => setSelectedDrawingForView(null),
    [],
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        backgroundColor: "#f2f2f2",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Patrol
          variant="liveMonitoring"
          selectedDrawingForView={selectedDrawingForView}
          onSelectDrawing={setSelectedDrawingForView}
          onClearSelectedDrawing={onClearSelectedDrawing}
        />
      </Box>
    </Box>
  );
}
